var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 12L10.5 14V10L14 12Z","stroke":"#1E2226","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2 12.707V11.292C2 8.39702 2 6.94902 2.905 6.01802C3.811 5.08602 5.237 5.04602 8.088 4.96502C9.438 4.92702 10.818 4.90002 12 4.90002C13.181 4.90002 14.561 4.92702 15.912 4.96502C18.763 5.04602 20.189 5.08602 21.094 6.01802C22 6.94902 22 8.39802 22 11.292V12.707C22 15.603 22 17.05 21.095 17.982C20.189 18.913 18.764 18.954 15.912 19.034C14.562 19.073 13.182 19.1 12 19.1C10.819 19.1 9.439 19.073 8.088 19.034C5.237 18.954 3.811 18.914 2.905 17.982C2 17.05 2 15.602 2 12.708V12.707Z","stroke":"#1E2226","strokeWidth":"1.5","key":1})]);
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
